
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole">
  <div class="row mt-2">
    <div class="col-12">
      <success #success></success>
    </div>
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Enter project details:</p>
      </div>
    </div>
  </div>
  <form #projectForm="ngForm">
    <div class="row justify-content-md-center mb-3">
      <div class="col-md-10 card-block">
        <div class="m-2">
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="required" for="name">Project Name:</label>
              <input class="form-control" id="name" type="text" [(ngModel)]="project.name" name="projectName" maxlength="40" required>
              <validation-error-display [error]="error" field="projectName"></validation-error-display>
            </div>
            <div class="form-group col-lg-6"></div>
          </div>
          <div class="row" *ngIf="targetSystem !== 'legacy'">
            <div class="form-group col-lg-6" *appSetting="'allowSettingUniqueId'">
              <label for="opportunityId">Opportunity ID:</label>
              <input class="form-control" id="opportunityId" [(ngModel)]="project.opportunityId" name="opportunityId" type="text">
              <validation-error-display [error]="error" field="opportunityId"></validation-error-display>
            </div>
            <div class="form-group col-lg-6" *appSetting="'allowSettingUniqueId'">
              <label for="uniqueId">Unique ID:</label>
              <input class="form-control" id="uniqueId" [(ngModel)]="project.uniqueId" name="uniqueId" type="text">
              <validation-error-display [error]="error" field="uniqueId"></validation-error-display>
            </div>
          </div>
          <div class="row" *ngIf="targetSystem !== 'legacy'">
            <div class="form-group col-lg-6">
              <label class="required" for="customerName">Customer Name:</label>
              <input class="form-control" id="customerName" [(ngModel)]="project.customerName" name="customerName" type="text" maxlength="140" required>
              <validation-error-display [error]="error" field="customerName"></validation-error-display>
            </div>
            <div class="form-group col-lg-6">
              <label class="required" for="customerBpId">Customer BP ID:</label>
              <input class="form-control" id="customerBpId" [readonly]="!canModifyCustomerBpId" [(ngModel)]="project.customerBpId" name="customerBpId" type="text" required>
              <validation-error-display [error]="error" field="customerBpId"></validation-error-display>
            </div>
          </div>
          <div class="row" *ngIf="targetSystem !== 'legacy'">
            <div class="col-lg-12">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" name="includeReseller" [(ngModel)]="project.includeReseller" autoLinkToLabel (change)="onToggleReseller()">
                <label class="form-check-label">Include Reseller Information</label>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="targetSystem !== 'legacy'">
            <div class="form-group col-lg-6">
              <label class="required" for="resellerName" *ngIf="project.includeReseller">Reseller Name:</label>
              <label class="text-secondary" for="resellerName" *ngIf="!project.includeReseller"><i>Reseller Name:</i></label>
              <input class="form-control" id="resellerName" *ngIf="project.includeReseller" [(ngModel)]="project.resellerName" name="resellerName" type="text" maxlength="140" [disabled]="!project.includeReseller" [required]="project.includeReseller">
              <div class="input-group border-bottom" *ngIf="!project.includeReseller"><span class="text-secondary pl-2">{{project.resellerName}}&nbsp;</span></div>
              <validation-error-display [error]="error" field="resellerName"></validation-error-display>
            </div>
            <div class="form-group col-lg-6">
              <label class="required" for="resellerBpId" *ngIf="project.includeReseller">Reseller BP ID:</label>
              <label class="text-secondary" for="resellerBpId" *ngIf="!project.includeReseller"><i>Reseller BP ID:</i></label>
              <input class="form-control" id="resellerBpId" *ngIf="project.includeReseller" [(ngModel)]="project.resellerBpId" name="resellerBpId" type="text" [disabled]="!project.includeReseller" [required]="project.includeReseller">
              <div class="input-group border-bottom" *ngIf="!project.includeReseller"><span class="text-secondary pl-2">{{project.resellerBpId}}&nbsp;</span></div>
              <validation-error-display [error]="error" field="resellerBpId"></validation-error-display>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="required">Country:</label>
              <select-country [inputId]="'country'" [(ngModel)]="project.countryId" name="countryIdWrapper" [inputName]="'countryId'" [disabled]="project.totalDevices &gt; 0" [geoRegionId]="project.geo_region_id" [error]="error" [countryId]="project.countryId" [textOnly]="project.totalDevices &gt; 0"></select-country>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-12">
              <label class="required" for="sourceDocumentationLink">Source Documentation Link (DealSource or MAD)</label>
              <input class="form-control" id="sourceDocumentationLink" [(ngModel)]="project.sourceDocumentationLink" name="sourceDocumentationLink" type="text" required>
              <validation-error-display [error]="error" field="sourceDocumentationLink"></validation-error-display>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <div class="inline-block">
                <label class="required" for="startDate">Project Start Date:
                  <help-dialog-button fieldName="Start Date" helpString="The approved project start date (typically requires contract signature)"></help-dialog-button>
                </label>
              </div>
              <div class="input-group">
                <input class="form-control bg-white" id="startDate" [(ngModel)]="project.startDate" name="startDate" type="text" required readonly>
                <datepicker class="right input-group-append" [(ngModel)]="project.startDate" name="startDateSelector" (outputEvents)="startDateChange($event)" required></datepicker>
                <validation-error-display [error]="error" field="startDate"></validation-error-display>
              </div>
            </div>
            <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="inline-block">
                <label class="required" for="customerKickoffDate">Customer Kickoff Date:</label>
              </div>
              <div class="input-group">
                <input class="form-control bg-white" id="customerKickoffDate" [(ngModel)]="project.customerKickoffDate" name="customerKickoffDate" type="text" required readonly>
                <datepicker class="right input-group-append" [(ngModel)]="project.customerKickoffDate" name="customerKickoffDateSelector" [options]="completionDateOptions" required></datepicker>
                <validation-error-display [error]="error" field="customerKickoffDate"></validation-error-display>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="inline-block">
                <label for="completionDate">Estimated Project Completion Date:
                  <help-dialog-button fieldName="Estimated Completion Date" helpString="The estimated date that all deployment deliverables will be completed for this customer project"></help-dialog-button>
                </label>
              </div>
              <div class="input-group">
                <input class="form-control bg-white" id="completionDate" [(ngModel)]="project.estimatedCompletionDate" name="estimatedCompletionDate" type="text" readonly>
                <datepicker class="right input-group-append" [(ngModel)]="project.estimatedCompletionDate" name="estimatedCompletionDateSelector" [options]="completionDateOptions" required></datepicker>
                <validation-error-display [error]="error" field="estimatedCompletionDate"></validation-error-display>
              </div>
            </div>
            <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="inline-block">
                <label for="estimatedProjectClosureDate">Estimated Project Closure Date:</label>
              </div>
              <div class="input-group">
                <input class="form-control bg-white" id="estimatedProjectClosureDate" [(ngModel)]="project.estimatedProjectClosureDate" name="estimatedProjectClosureDate" type="text" readonly>
                <datepicker class="right input-group-append" [(ngModel)]="project.estimatedProjectClosureDate" name="estimatedProjectClosureDateSelector" [options]="completionDateOptions" required></datepicker>
                <validation-error-display [error]="error" field="estimatedProjectClosureDate"></validation-error-display>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="required">Project Status:</label>
              <div>
                <div class="form-check float-left pr-4">
                  <input class="form-check-input" type="radio" name="status" [(ngModel)]="project.status" autoLinkToLabel value="open" (change)="onStatusChange()" [disabled]="project.status === 'draft' || project.status === 'archived'">
                  <label class="form-check-label">Open</label>
                  <validation-error-display [error]="error" field="status"></validation-error-display>
                </div>
              </div>
              <div class="form-check float-left pr-4">
                <input class="form-check-input" type="radio" name="status" [(ngModel)]="project.status" autoLinkToLabel value="hold" (change)="onStatusChange()" [disabled]="project.status === 'draft' || project.status === 'archived'">
                <label class="form-check-label">On Hold</label>
              </div>
              <div class="form-check float-left pr-4">
                <input class="form-check-input" type="radio" name="status" [(ngModel)]="project.status" autoLinkToLabel value="closed" (change)="onStatusChange()" [disabled]="project.status === 'draft' || project.status === 'archived'">
                <label class="form-check-label">Closed</label>
              </div>
              <div class="form-check float-left pr-4" *ngIf="project.status === 'draft'"> 
                <input class="form-check-input" id="statusDraft" type="radio" name="status" [(ngModel)]="project.status" autoLinkToLabel value="draft" [disabled]="project.status === 'draft' || project.status === 'archived'">
                <label class="form-check-label">Draft</label>
              </div>
              <div class="form-check float-left pr-4" *ngIf="project.status === 'archived'"> 
                <input class="form-check-input" id="statusArchived" type="radio" name="status" [(ngModel)]="project.status" autoLinkToLabel value="archived" [disabled]="project.status === 'draft' || project.status === 'archived'">
                <label class="form-check-label">Archived  </label>
              </div>
            </div>
            <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="inline-block">
                <label *ngIf="project.status === 'closed'">Actual Project Closure Date:</label>
                <label class="text-secondary" *ngIf="project.status !== 'closed'"><i>Actual Project Closure Date:</i></label>
              </div>
              <div class="input-group border-bottom"><span class="text-secondary pl-2">{{project.actualProjectClosureDate}}&nbsp;</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-md-10 card-block">
        <div class="m-2">
          <div class="row mb-2">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-6">
                  <div class="mt-2">
                    <h5 class="float-left">Additional Information</h5><i class="float-left text-secondary">&nbsp;(optional)</i>
                  </div>
                </div>
                <div class="col-lg-6 text-right"><a class="nav-link" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Hide additional information" *ngIf="toggleAdditional" (click)="toggleAdditional = false"><span class="icon oi oi-chevron-top"></span></a><a class="nav-link" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Show additional information" *ngIf="!toggleAdditional" (click)="toggleAdditional = true"><span class="icon oi oi-chevron-bottom"></span></a></div>
              </div>
            </div>
          </div>
          <ng-container *ngIf="toggleAdditional">
            <div class="row">
              <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
                <div class="row">
                  <div class="col-lg-6">
                    <label>First Install Date</label>
                  </div>
                  <div class="col-lg-6">
                    <div class="input-group border-bottom"><span class="text-secondary pl-2">{{project.firstInstallDate}}</span></div>
                  </div>
                </div>
              </div>
              <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
                <div class="row">
                  <div class="col-lg-6">
                    <label>First Order Date</label>
                  </div>
                  <div class="col-lg-6">
                    <div class="input-group border-bottom"><span class="text-secondary pl-2">{{project.firstOrderDate}}</span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="form-group col-lg-6">
                <div class="row">
                  <div class="col-lg-6 my-auto">
                    <label>Estimated Transition (months)</label>
                  </div>
                  <div class="col-lg-6">
                    <div class="input-group border-bottom">
                      <label class="text-muted">{{project.estimatedTransitionDate}}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group col-lg-6">
                <div class="row">
                  <div class="col-lg-6 my-auto">
                    <label>Actual Transition (months)</label>
                  </div>
                  <div class="col-lg-6">
                    <div class="input-group border-bottom">
                      <label class="text-muted">{{project.actualTransitionDate}}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-lg-6">
                <div class="row">
                  <div class="col-lg-6 my-auto">
                    <label for="totalCustomerValue">Total Contract Value (USD)</label>
                  </div>
                  <div class="col-lg-6">
                    <input class="form-control" id="totalCustomerValue" [(ngModel)]="project.totalCustomerValue" name="totalCustomerValue" type="number">
                    <validation-error-display [error]="error" field="totalCustomerValue"></validation-error-display>
                  </div>
                </div>
              </div>
              <div class="form-group col-lg-6 mt-2">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" name="requireMaiPagecounts" [(ngModel)]="project.requireMaiPagecounts" autoLinkToLabel>
                  <label class="form-check-label">Require MAI Initial Page Counts</label>
                  <validation-error-display [error]="error" field="requireMaiPagecounts"></validation-error-display>
                </div>
              </div>
              <div class="form-group col-lg-6" id="currency">
                <div class="row">
                  <div class="col-lg-6 my-auto">
                    <label>Currency</label>
                  </div>
                  <div class="col-lg-6">
                    <select class="form-control" [(ngModel)]="project.currency" name="currency">
                      <option value=""></option>
                      <option *ngFor="let code of currencyCodes" [value]="code">{{ code }}</option>
                    </select>
                    <validation-error-display [error]="error" field="currency"></validation-error-display>
                  </div>
                </div>
              </div>
              <div class="form-group col-lg-6">
                <div class="row">
                  <div class="col-lg-6 my-auto">
                    <label for="customerPin">Customer PIN</label>
                  </div>
                  <div class="col-lg-6">
                    <input class="form-control" id="customerPin" [(ngModel)]="project.customerPin" name="customerPin" type="text" maxlength="20">
                    <validation-error-display [error]="error" field="customerPin"></validation-error-display>
                  </div>
                </div>
              </div>
              <div class="form-group col-lg-6">
                <label for="sourceName">Source Name</label>
                <input class="form-control" id="sourceName" [(ngModel)]="project.sourceName" name="sourceName" type="text" maxlength="60">
                <validation-error-display [error]="error" field="sourceName"></validation-error-display>
              </div>
            </div>
            <div class="row mb-1">
              <div class="form-group col-lg-6">
                <label for="partnerPurchaseOrders">Partner Purchase Orders</label><span> (Add 1 per Line)</span>
                <textarea class="form-control" id="partnerPurchaseOrders" [(ngModel)]="partnerPurchaseOrders" name="partnerPurchaseOrders" rows="3"></textarea>
                <validation-error-display [error]="error" field="partnerPurchaseOrders"></validation-error-display>
              </div>
              <div class="form-group col-lg-6">
                <label for="partnerPurchaseOrders">Delivery Instructions For Every HWO</label>
                <textarea class="form-control" id="deliveryInformation" [(ngModel)]="project.deliveryInformation" name="deliveryInformation" rows="3"></textarea>
                <validation-error-display [error]="error" field="deliveryInformation"></validation-error-display>
              </div>
            </div>
            <div class="row mb-1">
              <div class="form-group col-lg-6">
                <label>Export TMC Data to Smartsheet Workspace</label>
                <table class="table table-striped">
                  <tbody>
                    <tr *ngFor="let workspace of project.workspaces;">
                      <td>{{workspace.name}}</td>
                    </tr>
                  </tbody>
                </table>
                <button class="btn btn-outline-primary" type="button" (click)="promptUserForSmartsheetWorkspaceId()">Select Smartsheet Workspace</button>
                <validation-error-display [error]="error" field="smartsheetWorkspace"></validation-error-display>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </form>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Fill out quality checklist:</p>
      </div>
    </div>
  </div>
  <div class="row justify-content-md-center" *ngIf="project">
    <div class="col-md-10 card-block">
      <div class="m-2">
        <h5 class="mt-2">Installation Quality Checklist</h5>
        <list-display-v2 [listStructure]="qualityChecklistData"></list-display-v2>
      </div>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Enter installation instructions:</p>
      </div>
    </div>
  </div>
  <div class="row justify-content-md-center">
    <div class="col-md-10 card-block">
      <div class="m-2">
        <div class="mt-2 border-bottom">
          <h5>MAI Installation Instructions</h5>
          <list-display-v2 [listStructure]="maiInstructionsData"></list-display-v2>
        </div>
        <h5 class="mt-4">Lease Installation Instructions</h5>
        <list-display-v2 [listStructure]="leaseInstructionsData"></list-display-v2>
      </div>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Enter Dashboard data:</p>
      </div>
    </div>
  </div>
  <div class="row justify-content-md-center">
    <div class="col-md-10 card-block">
      <div class="m-2">
        <div class="mt-2 border-bottom">
          <h5>Dashboard Milestones</h5>
          <list-display-v2 [listStructure]="milestoneData"></list-display-v2>
        </div>
        <h5 class="mt-4">Dashboard Issues</h5>
        <list-display-v2 [listStructure]="dashboardIssueData"></list-display-v2>
      </div>
    </div>
  </div>
</div>